import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const ProtectedRoute = ({ children }) => {
  const navigate = useNavigate();
  const [authed, setAuthed] = useState(null); // null = checking, true, false

  useEffect(() => {
    if (window.location.hash?.includes('session_id=')) return; // AuthCallback handles it
    (async () => {
      try {
        await axios.get(`${BACKEND_URL}/api/auth/me`, { withCredentials: true });
        setAuthed(true);
      } catch (err) {
        setAuthed(false);
        navigate('/admin/login', { replace: true });
      }
    })();
  }, [navigate]);

  if (authed === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-cream-200">
        <p className="text-forest-700 font-medium">Verifying access…</p>
      </div>
    );
  }
  if (!authed) return null;
  return children;
};

export default ProtectedRoute;
